import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.phase) {
            this.props.requireState();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.phase != this.props.phase) {
            return true;
        }

        return false;
    }

    render({ phase }) {
        if (phase) {
            const img_src = 'https://gfx.tarot.com/images/moon-phases/' + phase.slug + '.svg';
            return (
                <moon-phase className='row section'>
                    <div className='row section'>
                        <div className='large-2 small-4 columns'>
                            <img src={img_src} alt={phase.phase_name} />
                        </div>
                        <div className='large-10 small-12 columns'>
                            <h3>Current Moon Phase: {phase.phase_name}</h3>
                            <h4>{phase.illum}% Illumination</h4>
                        </div>
                    </div>
                    <div className='row section'>
                        <div className='large-11 small-12 columns'>
                            <p>{phase.date} — {phase.interp}</p>
                        </div>
                    </div>
                </moon-phase>
            );
        }

        return (<moon-phase />);
    }
}

const mapStateToProps = (state) => ({
    phase: state['moon-phase'],
});

const mapDispatchToProps = (dispatch) => ({
    requireState: () => dispatch({ type: 'moon-phase:init' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
